import { multiClientMiddleware } from 'redux-axios-middleware'

import { clients } from 'lib/axios'
import { yayApi } from '../api/baseApi'
import errorHandlerMiddleware from './errorHandlerMiddleware'
import authMiddleware from './authMiddleware'

export default [
  multiClientMiddleware(clients),
  yayApi.middleware,
  errorHandlerMiddleware,
  authMiddleware,
]
